module.exports = __webpack_public_path__ + "static/img/imperial_rabbit_1.af3e23e.png";